<script setup lang="ts">
import type AppAction from '@/models/core/AppAction';

const props = defineProps<{
  action: AppAction;
}>();
</script>

<template>
  <RouterLink v-if="props.action.route" v-slot="{ route }" custom :to="props.action.route">
    <a :href="route.href" @click="props.action.handler?.()">
      <slot :route="route">{{ props.action.label }}</slot>
    </a>
  </RouterLink>
  <button v-else-if="props.action.handler" type="button" @click="props.action.handler">
    <slot>{{ props.action.label }}</slot>
  </button>
  <span v-else>
    <slot>{{ props.action.label }}</slot>
  </span>
</template>
